// extracted by mini-css-extract-plugin
export default {"carousel":"LiteboxerGoProductPage_carousel__ngwhW"};